import NextButton from "legacy/boater-reservation-flow/NextButton"
import {
  centsToDollars,
  friendlyPricingStructureUnitName,
} from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class SelectElectric extends React.Component {
  constructor(props) {
    super(props)
    this.setElectric = this.setElectric.bind(this)
    this.getOptions = this.getOptions.bind(this)
    this.next = this.next.bind(this)
  }

  componentDidMount() {
    this.props.setHeader("Select Electric")
  }

  setElectric(event) {
    const { fetchV2PriceEstimate } = this.props.state
    const electricId = event.target.value
    this.props.setGlobalState({ electric_id: electricId }, fetchV2PriceEstimate)
  }

  electricDisplay(electricObject) {
    let powerType, pricePerNight
    if (this.props.state.mbm) {
      powerType = electricObject.name
      pricePerNight = electricObject.price_per_unit
    } else {
      powerType = electricObject.power_type
      pricePerNight = electricObject.price_per_night
    }
    const unitDisplay = this.props.state.mbm
      ? friendlyPricingStructureUnitName(
          electricObject.default_pricing_structure
        )
      : "per night"

    return powerType + " | " + centsToDollars(pricePerNight) + ` ${unitDisplay}`
  }

  getOptions() {
    const rows = []
    const electricArray = this.props.electricArray
    for (let i = 0; i < electricArray.length; i++) {
      rows.push(
        <option
          key={electricArray[i].id}
          value={electricArray[i].id}
          id={electricArray[i].id}
        >
          {this.electricDisplay(electricArray[i])}
        </option>
      )
    }
    return rows
  }

  next() {
    this.props.routeTo("next")
  }

  render() {
    return (
      <div id="selectElectric">
        <div className="form-group">
          <label htmlFor="electric">Electric</label>
          <select
            autoFocus
            className="form-control"
            id="electric"
            value={this.props.state.electric_id}
            onChange={this.setElectric}
          >
            <option value="">None</option>
            {this.getOptions()}
          </select>
        </div>
        <NextButton
          id="selectElectricContinueButton"
          btnClass="btn-primary"
          click={this.next}
          icon=""
          text="Continue"
        />
      </div>
    )
  }
}

SelectElectric.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  electricArray: PropTypes.array.isRequired,
  priceV2Endpoint: PropTypes.string,
}

export default SelectElectric
